package com.eladfinish.bible.contest.screens.mikud.model

import androidx.compose.runtime.Stable

enum class MikudType(val index: Int) {
    FULL(index = 0),
    YOUTH(index = 1),
    ADULTS(index = 2),
    SERVER(index = 3),
}

@Stable
data class MikudTypeData(
    val mikudType: MikudType,
    val text: String,
) {
    override fun toString(): String =
        text
}

@Stable
data class MikudLevelInfo(
    val intro: String,
    val part1: String,
    val part2: String,
)
